export const FILTER_MODIFIERS = [
  {
    label: 'is',
    value: 'IS',
  },
  {
    label: 'is not',
    value: 'IS_NOT',
  },
  {
    label: 'starts with',
    value: 'STARTS_WITH',
  },
  {
    label: 'is empty',
    value: 'IS_EMPTY',
  },
  {
    label: 'is not empty',
    value: 'IS_NOT_EMPTY',
  },
]
